module.exports = __webpack_public_path__ + "static/img/logo.2704d417.png";